import { render, staticRenderFns } from "./Show.vue?vue&type=template&id=a10692b2&scoped=true&"
import script from "./Show.vue?vue&type=script&lang=js&"
export * from "./Show.vue?vue&type=script&lang=js&"
import style0 from "./Show.vue?vue&type=style&index=0&id=a10692b2&prod&scoped=true&lang=css&"
import style1 from "./Show.vue?vue&type=style&index=1&id=a10692b2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a10692b2",
  null
  
)

export default component.exports